import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { IconTile } from '@atlaskit/icon';

import IconWithContent from '../IconWithContent';
import { FormattedMessage } from 'react-intl';
import { graphql } from 'relay-runtime';
import { useLazyLoadQuery } from 'react-relay';
import { useToken } from '../../../Flow/ConsentContextProvider';
import { NumberOfPeopleQuery as numberOfPeopleQuery } from '#generated/graphql/NumberOfPeopleQuery.graphql';

// There's a backend limitation that stops us from displaying numbers higher than 1,000 users
// This is the highest the backend will allow us to query for
const MAX_USER_COUNT = 1_000;

export const NumberOfPeople = () => {
  const { clientId } = useToken();
  const data = useLazyLoadQuery<numberOfPeopleQuery>(
    query,
    { clientId: clientId ?? '', maxUserCount: MAX_USER_COUNT },
    { fetchKey: clientId ?? '' },
  );
  const userCount = data?.oauthClients?.client?.consentedUserCount ?? 0;
  return (
    <IconWithContent
      icon={
        <IconTile
          icon={PeopleGroupIcon}
          label={''}
          appearance="gray"
          size="medium"
        />
      }
      text={
        <FormattedMessage
          id="trello.consentedUsers.main"
          defaultMessage="Used by {consentedUserCount}{moreThanIndicator, select, true {+} other {}} members"
          description="Number of users that have consented to this app. Used as a trust score to inform the user on whether they wish to trust this app. moreThanIndicator indicates that real number is more than what is shown."
          values={{
            consentedUserCount: userCount ?? '',
            moreThanIndicator: userCount === MAX_USER_COUNT,
          }}
        />
      }
    />
  );
};

const query = graphql`
  query NumberOfPeopleQuery($clientId: ID!, $maxUserCount: Int!) {
    oauthClients {
      client(id: $clientId) {
        consentedUserCount(max: $maxUserCount)
      }
    }
  }
`;
